module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-recharge"
  }, [_c('p', {
    staticClass: "channel-list-title"
  }, [_vm._v(_vm._s(_vm.$t('selectChannel')))]), _vm._v(" "), _c('div', {
    staticClass: "channel-list"
  }, _vm._l((_vm.channels), function(channel, channelIndex) {
    return _c('div', {
      staticClass: "channel-item",
      class: channel.key,
      on: {
        "click": function($event) {
          _vm.openContent(channelIndex)
        }
      }
    }, [_c('img', {
      staticClass: "channel-logo",
      attrs: {
        "src": '../../static/img/recharge/channels/' + channel.key + '.png'
      }
    })])
  })), _vm._v(" "), _c('recharge-popup', {
    attrs: {
      "channelInfo": _vm.channelInfo,
      "showRecharge": _vm.showRecharge,
      "channelId": _vm.channelId
    },
    on: {
      "closePopup": function($event) {
        _vm.showRecharge = false
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-58f6218c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/store/Recharge.vue
// module id = 379
// module chunks = 0